import React from "react";
import { NavLink } from "react-router-dom";

import "react-tippy/dist/tippy.css";
import { Helmet } from "react-helmet";

import logo from "./images/Logo provincie Zuid-Holland.svg";
import slogan from "./images/Krachtig Zuid-Holland.svg";
import ogimage from "./images/planmer-zuid-holland.jpg";

import dataPages from "./data/pages";

const Landing = () => {
  return (
    <div className="container">
      <header>
        <Helmet>
          <title>PlanMER • Provincie Zuid-Holland</title>
          <meta name="description" content="De milieueffectrapportages van de provincie Zuid-Holland." />
          <meta property="og:image" content={ogimage} />
        </Helmet>
        <div className="wrapperFull">
          <a href="/" className="logo">
            <img src={logo} alt="Provincie Zuid-Holland" />
          </a>
          <div className="headerMenu">
            {/* <div className="login"><a href="/admin" target="_blank"><i className="far fa-sign-in"></i>&nbsp;&nbsp;Inloggen</a></div> */}
          </div>
        </div>
      </header>
      <div className="pageTitle">
        <div className="wrapper">
          <div className="row">
            <div className="col-6">
              <h1>PlanMER</h1>
              <p>In het milieueffectrapport worden de milieugevolgen van het initiatief of de activiteit en reële alternatieven hiervoor systematisch, transparant en objectief in beeld gebracht. Milieueffectrapportage (mer) is wettelijk verankerd in de Omgevingswet. De mer-procedure is gekoppeld aan de procedure die moet worden doorlopen voor het betreffende plan of besluit.</p>
              <br />
            </div>
          </div>
        </div>
      </div>
      <div className="main">
        <div className="wrapper">
          <div className="row">
          <div className="col-2" key="gnephoek">
              <NavLink to="/gnephoek/" className="card">
                <div className='cardImage'>
                        <img src='/images/Herziening-Ontwikkeling-Gnephoek.jpg' alt='PlanMER Energietransitie' />
                    </div>
                <div className="cardContent">
                  <h3>MER Herziening Omgevingsbeleid Ontwikkeling Gnephoek</h3>
                  <div className="subtitle">Versie 11-03-2026 (Vastgesteld GS)</div>
                  <p>Het milieueffectrapport (MER) voor de Herziening Omgevingsbeleid Ontwikkeling Gnephoek van het Omgevingsbeleid van de provincie Zuid-Holland.</p>
                  <div className="btn">Lees meer</div>
                </div>
              </NavLink>
            </div>
          <div className="col-2" key="energie">
              <NavLink to="/energietransitie/samenvatting" className="card">
                <div className='cardImage'>
                        <img src={require('./data/energietransitie/images/Milieueffectrapportage Module Energietransitie.jpg')} alt='PlanMER Energietransitie' />
                    </div>
                <div className="cardContent">
                  <h3>Milieueffectrapportage Module Energietransitie</h3>
                  <div className="subtitle">Versie 04-10-2022 (Vastgesteld GS)</div>
                  <p>Het milieueffectrapport (MER) voor de herziening van de module Energietransitie van het Omgevingsbeleid van de provincie Zuid-Holland. </p>
                  <div className="btn">Lees meer</div>
                </div>
              </NavLink>
            </div>

            {dataPages.pages.filter(page => page.showFrontpage).map(page => 

                <div className="col-2" key={page.url}>
                  <NavLink to={page.url} className="card">
                    <div className='cardImage'>
                            <img src={'.'+ page.image} alt={page.title} />
                        </div>
                    <div className="cardContent">
                      <h3>{page.title}</h3>
                      <div className="subtitle">Versie {page.date}</div>
                      <p>{page.description}</p>
                      <div className="btn">Lees meer</div>
                    </div>
                  </NavLink>
                </div>
            )}
          </div>
        </div>
      </div>
      <footer>
        <div className="wrapper">
          <div className="motto">
            <img src={slogan} alt="Krachtig Zuid-Holland" />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Landing;
